/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".app-page-title[_ngcontent-%COMP%]{padding-top:20px;padding-bottom:20px;margin-bottom:25px}"];
export { styles as styles };
